import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { LoadingButton } from '@mui/lab';
import { Box, Button, CardContent, DialogTitle, ListItemIcon, Paper } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonHelper } from 'src/utils/commonHelper';

const ThreadsAuthorizationModal = (props) => {
  const { t: translate } = useTranslation();
  const [isLoadingOn, setLoadingOn] = useState(false);
  const isCustomDomain = CommonHelper.CustomDomain();
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");
  const handleConnectThreads = () => {
    setLoadingOn(true);
    props.handleConnectThreads();
  };

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open>
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <Typography gutterBottom variant="h4">
          {translate('integration.threads.threads_to_business')}?
        </Typography>
        {(!isCustomDomain || isPortalAdmin) && (
          <Box display="flex" justifyContent="center" alignItems="center">
            <Button
              variant="outlined"
              startIcon={<YouTubeIcon />}
              onClick={() => window.open('https://www.youtube.com/watch?v=RECXgZ9O_3U', '_blank')}
              color="primary"
            >
              {translate('common.tutorial')}
            </Button>
          </Box>
        )}
      </DialogTitle>
      <DialogContent dividers>
        <CardContent
          sx={{
            p: { xs: 0, md: 0 },
            color: 'grey.800',
          }}
        >
          <Typography variant="body1" sx={{ mx: 'auto', fontWeight: 'bold' }}>
            {translate('common.make_sure_completed_steps')}
          </Typography>
          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1, mt: 2 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">{translate('integration.threads.signed_your_google_account')}.</Typography>
          </Paper>
          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">{translate('integration.threads.trustworthy_and_user_friendly')}</Typography>
          </Paper>
          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">{translate('integration.threads.trustworthy_and_user_friendly')}</Typography>
          </Paper>
        </CardContent>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          {translate('common.close')}
        </Button>
        <LoadingButton
          variant="contained"
          loading={isLoadingOn}
          autoFocus
          onClick={() => {
            handleConnectThreads();
          }}
        >
          {translate('common.connect')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default ThreadsAuthorizationModal;
